import { Routes } from '@angular/router';
import { authGuard, publicOnlyGuard, homeGuard } from './services/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    canActivate: [homeGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [publicOnlyGuard]
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/signup/signup').then(m => m.SignupComponent),
    canActivate: [publicOnlyGuard]
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/verify-email/verify-email').then(m => m.VerifyEmailComponent),
    canActivate: [publicOnlyGuard]
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./pages/auth/auth-callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'farm-schedule',
    loadComponent: () => import('./pages/farm-schedule/farm-schedule.component').then(m => m.FarmScheduleComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quick-planting',
    loadComponent: () => import('./pages/crop-select/crop-select.component').then(m => m.CropSelectComponent),
    canActivate: [authGuard]
  },
  {
    path: 'favorites',
    redirectTo: 'quick-planting',
    pathMatch: 'full'
  },
  {
    path: 'crop-select',
    redirectTo: 'quick-planting',
    pathMatch: 'full'
  },
  {
    path: 'crop-selection',
    redirectTo: 'quick-planting',
    pathMatch: 'full'
  },
  {
    path: 'crops',
    loadComponent: () => import('./components/crop-list/crop-list.component').then(m => m.CropListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fields',
    loadComponent: () => import('./pages/fields/fields.page').then(m => m.FieldsPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'fields/:fieldId',
    loadComponent: () => import('./pages/fields/field-detail.page').then(m => m.FieldDetailPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'plantings',
    loadComponent: () => import('./pages/plantings/plantings.page').then(m => m.PlantingsPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'todos',
    loadComponent: () => import('./pages/todos/todo-dashboard.page').then(m => m.TodoDashboardPageComponent),
    canActivate: [authGuard]
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPage)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPage)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage)
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms-of-service/terms-of-service.page').then(m => m.TermsOfServicePage)
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPageComponent)
  }
];
